/**
 * Whether a checkpoint's exclusive edit lock is currently held by any Access.
 * Used to replace ⋮ operations menus with the lock indicator (Rule 5).
 */
export function isCheckpointEditLockHeld(checkpoint) {
  if (!checkpoint || typeof checkpoint !== "object") return false;
  if (checkpoint.lock_checkpoint != null) return Boolean(checkpoint.lock_checkpoint);
  return Boolean(checkpoint.locked);
}
